import React, { useState, useEffect } from 'react';

import {
	PieChart,
	Pie,
	Cell,
	Legend,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

export function GraficoBandeira(props) {
	const { data, loading } = props;
	const [grafico, setGrafico] = useState([
		{
			name: '',
			value: 0,
		},
	]);
	const COLORS = [
		color.primary,
		color.secondary,
		color.blue,
		color.yellow,
		color.gray,
		color.red,
		color.green,
		color.orange,
		color.redDark,
		color.purple,
		color.grayDark,
	];

	useEffect(() => {
		const dataArray = [];
		for (let i = 0; i < data.length; i += 1) {
			dataArray.push({
				name: data[i].bandeira.toUpperCase(),
				value: data[i].quantidade,
			});
		}
		setGrafico(dataArray);
	}, [data]);

	if (loading) {
		return (
			<div
				className="d-flex align-items-center justify-content-center"
				style={{ height: '400px' }}>
				<LoaderMini width="70" />
			</div>
		);
	}

	if (!loading && grafico.length === 0) {
		return <Text>Sem resultados no periodo</Text>;
	}

	return (
		<div style={{ width: '100%', height: 400 }}>
			<ResponsiveContainer>
				<PieChart width={400} height={350}>
					<Pie
						data={grafico}
						dataKey="value"
						innerRadius={60}
						outerRadius={90}>
						{grafico.slice(0, 9).map((entry, index) => (
							<Cell
								key={`cell-${entry}`}
								fill={COLORS[index % COLORS.length]}
							/>
						))}
					</Pie>
					<Tooltip />
					<Legend />
				</PieChart>
			</ResponsiveContainer>
		</div>
	);
}

GraficoBandeira.propTypes = {
	data: PropTypes.oneOfType([PropTypes.array]),
	loading: PropTypes.bool.isRequired,
};

GraficoBandeira.defaultProps = {
	data: [],
};
